module.exports = __webpack_public_path__ + "static/media/FUEL-BNB.27192eee.png";